import React from 'react';
import { Icon } from 'semantic-ui-react';

import { formatBRL, HireSummaryData } from './hireValues';
import * as S from './styles';

type Props = {
  data: HireSummaryData;
};

const SummaryRow = ({
  label,
  value,
  badge
}: {
  label: string;
  value: string;
  badge?: React.ReactNode;
}) => (
  <S.Row>
    <div>
      <S.RowLabel>{label}</S.RowLabel>
      <S.RowValue>{value}</S.RowValue>
    </div>
    {badge}
  </S.Row>
);

// Campos ausentes não são exibidos: cada seguradora entrega um conjunto diferente de valores
const HireSummary = ({ data }: Props) => {
  const { plan, assistance, installments } = data;

  return (
    <S.Section>
      <S.SectionTitle>Resumo da contratação</S.SectionTitle>
      <S.Card>
        {plan && (
          <SummaryRow
            label="Plano"
            value={plan.name}
            badge={
              plan.monthlyValue ? (
                <S.Badge variant="primary">{formatBRL(plan.monthlyValue)}/mês</S.Badge>
              ) : undefined
            }
          />
        )}
        {assistance && (
          <SummaryRow
            label="Assistência"
            value={assistance.name}
            badge={
              assistance.monthlyValue > 0 ? (
                <S.Badge variant="primary">+ {formatBRL(assistance.monthlyValue)}/mês</S.Badge>
              ) : (
                <S.Badge variant="success">Incluso</S.Badge>
              )
            }
          />
        )}
        {data.planPremium !== undefined && (
          <SummaryRow label="Prêmio do plano" value={formatBRL(data.planPremium)} />
        )}
        {data.assistancePremium !== undefined && (
          <SummaryRow label="Prêmio da assistência" value={formatBRL(data.assistancePremium)} />
        )}
        {data.quotedPremium !== undefined && (
          <SummaryRow label="Prêmio cotado" value={formatBRL(data.quotedPremium)} />
        )}
        {data.totalPremium !== undefined && (
          <SummaryRow label="Prêmio total" value={formatBRL(data.totalPremium)} />
        )}
      </S.Card>

      {installments && (
        <S.InstallmentsBox>
          <S.InstallmentsLabel>
            <S.CurrencyIcon aria-hidden="true">$</S.CurrencyIcon>
            Valor das parcelas
          </S.InstallmentsLabel>
          <S.InstallmentsValue>
            {installments.quantity}x de {formatBRL(installments.value)}
          </S.InstallmentsValue>
        </S.InstallmentsBox>
      )}

      {data.notice && (
        <S.Notice>
          <Icon name="info circle" />
          {data.notice}
        </S.Notice>
      )}
    </S.Section>
  );
};

export default HireSummary;
